import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  ButtonForwardRef,
  CardContent,
  CurrencyInput,
  Dialog,
  DialogContent,
  TextField,
} from "../../../../../components";
import { TefHubService } from "../../../../../services";
import palette from "../../../../../styles/light-theme/palette";
import { DATATYPE_TEF } from "../../../../../resources";
import { unformatPrice } from "../../../../../utils";
import { value } from "../../../../../helpers";
import QRCode from "react-qr-code";
import VerificationInput from "react-verification-input";
import Mousetrap from "mousetrap";

const logo = "https://public.siafevolution.com.br/icon-lite.svg";
const tefHubService = new TefHubService();

const MenuAdministracaoTef = ({
  open,
  setOpen,
  dadosMenuTef,
  tefConnection,
}) => {
  const {
    dataType,
    tipoCampo,
    titulo,
    itensMenu,
    mensagem,
    tamanhoMinimo,
    tamanhoMaximo,
    qrCode,
  } = dadosMenuTef || {};

  const [valueCurrency, setValueCurrency] = useState(null);
  const [respostaSitef, setRespostaSitef] = useState("1");
  const modulosConfirmacao = [DATATYPE_TEF.CONFIRMATION, DATATYPE_TEF.QRCODE];

  const respostaRef = useRef(respostaSitef);
  const dataTypeRef = useRef(dataType);
  const itensMenuSizeRef = useRef(itensMenu?.length);
  const itemRefs = useRef([]);

  const botaoContinuarRef = useRef(null);
  const botaoConfirmarRef = useRef(null);
  const botaoCancelarRef = useRef(null);

  const atalhosMenuAdm = [
    {
      keys: ["enter"],
      action: (e) => {
        e.preventDefault();
        if (dataTypeRef.current === DATATYPE_TEF.MENU) {
          if (botaoContinuarRef.current) {
            const el = botaoContinuarRef.current;
            mockButtonClick(el);
          }
        } else if (dataTypeRef.current === DATATYPE_TEF.CONFIRMATION) {
          if (botaoConfirmarRef.current) {
            const el = botaoConfirmarRef.current;
            mockButtonClick(el);
          }
        }
        return false;
      },
    },
    {
      keys: ["esc"],
      action: (e) => {
        if (dataTypeRef.current === DATATYPE_TEF.CONFIRMATION) {
          e.preventDefault();
          const el = botaoCancelarRef.current;
          mockButtonClick(el);
        }
        return false;
      },
    },
    {
      keys: ["up"],
      action: () => {
        if (dataTypeRef.current === DATATYPE_TEF.MENU) {
          const index = parseInt(respostaRef.current ?? "1") - 1;
          if (index > 0) {
            setRespostaSitef(`${index}`);
          }
        }
        return false;
      },
    },
    {
      keys: ["down"],
      action: () => {
        if (dataTypeRef.current === DATATYPE_TEF.MENU) {
          const index = parseInt(respostaRef.current ?? "1") + 1;
          if (index <= itensMenuSizeRef.current) {
            setRespostaSitef(`${index}`);
          }
        }
        return false;
      },
    },
  ];

  const mockButtonClick = (el) => {
    el.dispatchEvent(new MouseEvent("mousedown", { bubbles: true }));

    setTimeout(() => {
      el.dispatchEvent(new MouseEvent("mouseup", { bubbles: true }));
      el.dispatchEvent(new MouseEvent("click", { bubbles: true }));
    }, 200);
  };

  useEffect(() => {
    if (!open) return;

    setRespostaSitef("1");
    atalhosMenuAdm.map(({ keys, action }) => Mousetrap.bind(keys, action));

    return () => {
      atalhosMenuAdm.map(({ keys }) => Mousetrap.unbind(keys));
    };
  }, [open]);

  useEffect(() => {
    respostaRef.current = respostaSitef;
    const index = parseInt(respostaSitef ?? "1") - 1;
    const el = itemRefs.current[index];
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [respostaSitef]);

  useEffect(() => {
    dataTypeRef.current = dataType;
    itensMenuSizeRef.current = itensMenu?.length;
    itemRefs.current =
      itensMenu?.map((_, i) => itemRefs.current[i] ?? React.createRef()) ?? [];
  }, [dadosMenuTef]);

  Mousetrap.stopCallback = function () {
    return false;
  };

  const handleChangeCurrency = (event) => {
    const valor = parseFloat(unformatPrice(event.target.value));
    setValueCurrency(valor);
    setRespostaSitef(parseInt(valor * 100));
  };

  const handleChangeNumber = (event) => {
    const value = event.target.value;
    const length = value?.length ?? 0;
    if (length <= tamanhoMaximo) {
      setRespostaSitef(event.target.value);
    }
  };

  const onCompleteCodigoSupervisor = (value) => {
    setRespostaSitef(value);
  };

  const callbackSitef = async (interromper, voltar, respostaSitef) => {
    await tefHubService.callback({
      interromper,
      voltar,
      respostaSitef: respostaSitef.toString(),
    });
    setRespostaSitef(null);
    setValueCurrency(null);
  };

  const renderMenuTef = () => {
    switch (dataType) {
      case DATATYPE_TEF.CURRENCY:
        return (
          <>
            <span style={{ fontWeight: 600, fontSize: 16 }}>{titulo}</span>
            <CurrencyInput
              id="valor"
              variant="outlined"
              required
              value={value.text(valueCurrency)}
              onChange={handleChangeCurrency}
              fullWidth
            />
          </>
        );
      case DATATYPE_TEF.NUMERIC:
        return tipoCampo === 500 ? (
          <>
            <span style={{ fontWeight: 600, fontSize: 16 }}>{titulo}</span>
            <VerificationInput
              autoFocus
              onComplete={onCompleteCodigoSupervisor}
              passwordMode
              classNames={{
                container: "validationInput",
                character: "validationInput-caracter",
              }}
              validChars="0-9"
            />
          </>
        ) : (
          <>
            <span style={{ fontWeight: 600, fontSize: 16 }}>{titulo}</span>
            <TextField
              id="valor"
              variant="outlined"
              margin="normal"
              type="number"
              fullWidth
              value={value.text(respostaSitef)}
              onChange={handleChangeNumber}
            />
          </>
        );
      case DATATYPE_TEF.MENU:
        return (
          <Box className="d-flex flex-column gap-4">
            <span style={{ fontWeight: 600, fontSize: 16 }}>{titulo}</span>
            <Box
              className="px-5 d-flex flex-column gap-2"
              sx={{
                maxHeight: 300,
                overflowY: "auto",
                width: "100%",
              }}
            >
              {itensMenu?.map((item, i) => (
                <div key={i} ref={(el) => (itemRefs.current[i] = el)}>
                  <Button
                    fullWidth
                    variant="contained"
                    size="small"
                    className="mt-2 rounded-3"
                    disableElevation
                    onClick={() => setRespostaSitef(`${i + 1}`)}
                    sx={{
                      backgroundColor:
                        respostaSitef === `${i + 1}`
                          ? palette.primary
                          : "white",
                      color: respostaSitef === `${i + 1}` ? "white" : "black",
                    }}
                  >
                    {item}
                  </Button>
                </div>
              ))}
            </Box>
          </Box>
        );
      case DATATYPE_TEF.CONFIRMATION:
        return (
          <>
            <span
              style={{ fontWeight: 600, fontSize: 16, whiteSpace: "pre-line" }}
            >
              {mensagem}
            </span>
            <div className="d-flex flex-row gap-2">
              <ButtonForwardRef
                ref={botaoConfirmarRef}
                color="primary"
                variant="contained"
                onClick={() => callbackSitef(false, false, "0")}
              >
                <i
                  className="ph-fill ph-check-circle"
                  style={{ fontSize: 22, marginRight: 10, color: "white" }}
                />
                Confirmar
              </ButtonForwardRef>
              <ButtonForwardRef
                ref={botaoCancelarRef}
                color="inherit"
                variant="contained"
                onClick={() => callbackSitef(true, false, "1")}
              >
                <i
                  className="ph-fill ph-x-circle"
                  style={{ fontSize: 22, marginRight: 10 }}
                />
                Cancelar
              </ButtonForwardRef>
            </div>
          </>
        );
      default:
        return (
          <>
            {mensagem && (
              <span style={{ fontWeight: 600, fontSize: 16 }}>{mensagem}</span>
            )}
            {qrCode ? (
              <QRCode value={qrCode} style={{ height: "fit-content" }} />
            ) : (
              <img
                src={logo}
                id="logosiaf"
                alt="Logo SIAF"
                className="rotate-center w-25"
              />
            )}
          </>
        );
    }
  };

  const validateTamanhoRespostaSitef = () => {
    return tamanhoMinimo && respostaSitef
      ? respostaSitef.toString().length >= tamanhoMinimo
      : respostaSitef;
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      PaperComponent="div"
      PaperProps={{
        style: {
          borderRadius: "0.7rem",
          background: `linear-gradient(180deg, ${palette.white} 98%, ${palette.white} 98%, ${palette.primary.main} 2%)`,
        },
      }}
      open={open}
      onClose={() => setOpen(false)}
      disableEscapeKeyDown
    >
      <DialogContent
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 4,
        }}
      >
        <h6 className="text-center text-uppercase fw-bold mb-0">
          Administração TEF
        </h6>
        <CardContent
          sx={{
            p: 0,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
          }}
        >
          {renderMenuTef()}
          {dataType && !modulosConfirmacao.includes(dataType) && (
            <ButtonForwardRef
              ref={botaoContinuarRef}
              color="primary"
              variant="contained"
              disabled={!validateTamanhoRespostaSitef()}
              onClick={() => callbackSitef(false, false, respostaSitef)}
            >
              Continuar
            </ButtonForwardRef>
          )}
          {dataType && dataType === DATATYPE_TEF.QRCODE && (
            <ButtonForwardRef
              ref={botaoCancelarRef}
              color="inherit"
              variant="contained"
              onClick={() => tefConnection.invokeInterrompeRequisicaoTef()}
            >
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              />
              Cancelar
            </ButtonForwardRef>
          )}
        </CardContent>
      </DialogContent>
    </Dialog>
  );
};

export default MenuAdministracaoTef;
